var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBannerImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#C9C9C9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 31,
    r: 6,
    fill: "#C9C9C9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 56,
    r: 6,
    fill: "#C9C9C9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 81,
    r: 6,
    fill: "#C9C9C9"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 106,
    r: 6,
    fill: "#C9C9C9"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 6,
    r: 6,
    fill: "#C9C9C9"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 31,
    r: 6,
    fill: "#C9C9C9"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 56,
    r: 6,
    fill: "#C9C9C9"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 81,
    r: 6,
    fill: "#C9C9C9"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 106,
    r: 6,
    fill: "#C9C9C9"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 6,
    r: 6,
    fill: "#C9C9C9"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 31,
    r: 6,
    fill: "#C9C9C9"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 56,
    r: 6,
    fill: "#C9C9C9"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 81,
    r: 6,
    fill: "#C9C9C9"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 106,
    r: 6,
    fill: "#C9C9C9"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 6,
    r: 6,
    fill: "#C9C9C9"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 31,
    r: 6,
    fill: "#C9C9C9"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 56,
    r: 6,
    fill: "#C9C9C9"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 81,
    r: 6,
    fill: "#C9C9C9"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 106,
    r: 6,
    fill: "#C9C9C9"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 6,
    r: 6,
    fill: "#C9C9C9"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 31,
    r: 6,
    fill: "#C9C9C9"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 56,
    r: 6,
    fill: "#C9C9C9"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 81,
    r: 6,
    fill: "#C9C9C9"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 106,
    r: 6,
    fill: "#C9C9C9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerImage);
export default __webpack_public_path__ + "static/media/banner-image.295d7c72d5911ee36d908d2f2270c3d6.svg";
export { ForwardRef as ReactComponent };